import React, { Component } from 'react';
import { UserActions, ServiceActions, CalendarActions } from '../../../store/actions';
import { connect } from 'react-redux';
import { TrayvoBlue } from '../../../assets/img';
import { Form } from 'react-bootstrap';
import { CFormGroup } from '@coreui/react';
import ButtonLoader from 'react-loader-spinner';
import NumberFormat from 'react-number-format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { DurationPicker } from '../DurationPicker';
import Select from 'react-select';
import { Loader } from '../Loader';
import { accentColor, availableSlots, privacySettings, trainingOption } from '../../../constants';
import { SelectionButton, ToggleButton, ModalBackground, InputLabel } from '../../Shared';
import ServiceLocation from './ServiceLocation';
import {
  notify,
  priceFormatter,
  removeSpecialCharacters,
  checkMinimumFee,
  getConsumerUrl,
  isTrainingLocationPresent,
} from '../../../utils/utilities';
import { addConnectionDetailsGuide, addLocationGuide } from '../../../stringConstants';
import Tour from 'reactour';
import ImageEdit from '../../Shared/ImageEdit';

let connectProps = {
  ...UserActions,
  ...ServiceActions,
  ...CalendarActions,
};

let connectState = state => ({
  providedServices: state.Service.service.get('providedServices'),
  singleService: state.Service.service.get('singleService'),
  services: state.Service.service.get('services'),
  loader: state.User.meta.get('showHUD'),
  currentUser: state.User.current.get('currentUser'),
  buttonLoading: state.User.meta.get('buttonLoading'),
});

let enhancer = connect(connectState, connectProps);

const initialStates = {
  editVisible: false,
  serviceObj: null,
  duration: 'Min',
  minDuration: null,
  cusDuration: null,
  link: '',
  price: '',
  desc: '',
  trainingImage: '',
  connectionDetails: '',
  selectedTraining: null,
  trainingImageFile: null,
  service: '',
  privacySetting: null,

  status: 'published',
  locations: [],
  locationsNew: [],
  eventName: '',
  training_type: null,
  maxSeats: null,
};

class EditTraining extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialStates,
      showGuide: false,
    };
  }

  async componentDidMount() {
    let { showHUD, clearSingleService, getSingleService, serviceId } = this.props;

    showHUD();
    clearSingleService();
    let data = await getSingleService(serviceId);

    if (data?.data?.attributes) {
      let dur = parseInt(data.data.attributes.duration).toString();

      if (!(dur === '30' || dur === '45' || dur === '60')) {
        this.setState({ cusDuration: dur });
      }

      this.setState({
        minDuration: dur,
        price: priceFormatter(data.data.attributes.price),
        desc: data.data.attributes.discription,
        trainingImage: data.data.attributes.image_url,
        link: data.data.attributes.slug.split('-')[1],
        locations: data.data.attributes.provided_service_locations.data,
        connectionDetails: data.data.attributes.connection_detail,
        eventName: data.data.attributes.name,
        privacySetting:
          data.data.attributes.privacy_setting === 'public'
            ? privacySettings[0]
            : privacySettings[1],
        training_type:
          data.data.attributes.training_type === 'virtual'
            ? trainingOption.VIRTUAL
            : data.data.attributes.training_type === 'individual'
            ? trainingOption.INDIVIDUAL
            : trainingOption.GROUP,

        maxSeats: { label: data.data.attributes.max_seats, value: data.data.attributes.max_seats },
        showGuide: isTrainingLocationPresent(data.data.attributes),
      });
    }
  }

  async submit(e) {
    e.preventDefault();

    let {
      trainingImage,
      trainingImageFile,
      status,
      link,
      cusDuration,
      minDuration,
      locationsNew,
      locations,
      eventName,
      connectionDetails,
      privacySetting,
      training_type,
      maxSeats,
      price,
      desc,
    } = this.state;

    let { currentUser, singleService } = this.props;

    if (!cusDuration && !minDuration) {
      notify('Select a duration');
      return;
    }

    if (checkMinimumFee(price)) return;

    this.props.changeButtonLoading(true);

    let payload = {
      provided_service: {
        discription: desc,
        slug_title: `${currentUser.attributes.slug}/${removeSpecialCharacters(link)}`,
        price: price,
        status,
        name: eventName,
        duration: parseInt(cusDuration ? cusDuration : minDuration),
        privacy_setting: privacySetting
          ? privacySetting.value
          : singleService.attributes.privacy_setting === 'public'
          ? 1
          : 2,
        training_type:
          training_type === trainingOption.VIRTUAL
            ? 1
            : training_type === trainingOption.INDIVIDUAL
            ? 2
            : 3,
        provided_service_locations_attributes: locations
          .map(item => ({
            id: item.attributes.id,
            location: item.attributes.location,
            address: item.attributes.address,
            _destroy: item.attributes._destroy ? true : false,
          }))
          .concat(
            locationsNew.map(item => ({
              location: item.location,
              address: item.address,
            }))
          ),
      },
    };

    if (training_type === trainingOption.VIRTUAL)
      payload.provided_service.connection_detail = connectionDetails;

    if (training_type === trainingOption.GROUP)
      payload.provided_service.max_seats = maxSeats
        ? maxSeats.value
        : singleService.attributes.max_seats;

    if (trainingImage && trainingImageFile) {
      let data = await this.props.getTrainingSignedUrl();
      await this.props.uploadImage(trainingImageFile, data.signed_url);
      payload.provided_service.image_url = data.url;
    }

    await this.props.updateProvidedService(singleService.attributes.id, payload);
    await this.props.getProvidedServices();
    const { data: providedService } = await this.props.getSingleService(
      singleService.attributes.id
    );

    this.props.setSelectedTraining({
      trainingType: providedService.attributes.training_type,
      trainingId: providedService.attributes.id,
    });

    this.props.changeButtonLoading(false);

    this.setState({ ...initialStates }, () => {
      notify('Updated successfully', 'success');
      this.props.closePopup({
        showAvailabilityPopup: !providedService?.attributes?.availability_set,
      });
    });
  }

  onImageChange = async e => {
    const file = e.target.files[0];
    const image = URL.createObjectURL(file);
    this.setState({ trainingImage: image, trainingImageFile: file });
  };

  onChange = (tag, value) => {
    this.setState({ [tag]: value });
  };

  updatePublishedStatus = async (id, status) => {
    await this.props.updateProvidedService(id, {
      provided_service: {
        status: status,
      },
    });
    await this.props.getSingleService(id);
  };

  addLocation = () => {
    let { locationsNew } = this.state;
    this.setState({
      showGuide: false,
      locationsNew: [...locationsNew, { id: locationsNew.length + 1, location: '', address: '' }],
    });
  };

  removeOldLocation = id => {
    let { locations } = this.state;
    let removeLocations = locations.map(item => {
      if (item.attributes.id === id) item.attributes['_destroy'] = true;
      return item;
    });

    this.setState({
      locations: removeLocations,
    });
  };

  removeNewLocation = id => {
    let { locationsNew } = this.state;
    let removeLocations = locationsNew.filter(item => item.id !== id);
    this.setState({
      locationsNew: removeLocations,
    });
  };

  onUpdateOldLocations = (id, tag, value) => {
    let { locations } = this.state;
    let updatedLocations = locations.map(item => {
      if (item.attributes.id === id) item.attributes[tag] = value;
      return item;
    });

    this.setState({ locations: updatedLocations });
  };

  onUpdateNewLocations = (id, tag, value) => {
    let { locationsNew } = this.state;
    let updatedLocations = locationsNew.map(item => {
      if (item.id === id) item[tag] = value;
      return item;
    });
    this.setState({ locationsNew: updatedLocations });
  };

  render() {
    let { buttonLoading, currentUser, singleService, loader } = this.props;

    let {
      minDuration,
      cusDuration,
      price,
      link,
      trainingImage,
      training_type,
      desc,
      locations,
      locationsNew,
      locationAddress,
      eventName,
      privacySetting,
      connectionDetails,
      maxSeats,
    } = this.state;

    return (
      <div
        className={
          this.props.isVisible
            ? `fixed pin pb-4 inset-0 inset-x-0 inset-y-0 flex items-center justify-center z-10`
            : 'hidden'
        }>
        <ModalBackground />

        <div
          class="bg-white overflow-scroll max-h-screen shadow-xl transform transition-all w-full border-gray-700 border"
          role="dialog"
          aria-modal="true"
          style={{ width: '500px', height: window.innerHeight / 1.1, borderRadius: '10px' }}
          aria-labelledby="modal-headline">
          <div className="p-2">
            <div className="flex justify-between items-center px-4 py-10">
              <div>
                <ToggleButton
                  status={singleService?.attributes?.status}
                  training={singleService?.attributes}
                  id={0}
                  handleOnToggle={() => {
                    this.updatePublishedStatus(
                      singleService?.attributes?.id,
                      singleService?.attributes?.status === 'published'
                        ? 'unpublished'
                        : 'published'
                    );
                  }}
                />
              </div>

              <small className="text-sm text-black">Update Training Option</small>

              <button
                type="button"
                onClick={() => this.props.closePopup()}
                className="p-1 rounded-lg py-2 focus:outline-none">
                <small className="hover:text-blue-500 text-primary-color font-medium">X</small>
              </button>
            </div>

            {!loader && singleService?.attributes ? (
              <div class="flex py-1 flex-col bg-extra-gray rounded-md items-center">
                <small className="text-black font-sf-regular text-xs">
                  Last edited{' '}
                  {moment(singleService?.attributes?.updated_at).format('LL, h:mm:ss a')}
                </small>

                {singleService?.attributes?.status === 'published' && (
                  <a
                    className="font-sf-regular underline text-blue-400 "
                    href={`${getConsumerUrl()}/${singleService.attributes.slug.replace(/-/g, '/')}`}
                    target="_blank">
                    <FontAwesomeIcon
                      icon={faExternalLinkAlt}
                      style={{ color: '#67B4EB', marginRight: 10 }}
                    />
                    view live page
                  </a>
                )}

                <form
                  className="w-full"
                  onSubmit={e => {
                    this.submit(e);
                  }}>
                  <div className="px-10">
                    <div className="flex items-center justify-center my-2 flex-col ">
                      <img
                        className="rounded-full object-cover h-20 w-20 shadow-md"
                        src={trainingImage ? trainingImage : TrayvoBlue}
                      />

                      <ImageEdit
                        afterEditDone={(image, imageFile) => {
                          this.setState({ trainingImage: image, trainingImageFile: imageFile });
                        }}
                      />
                    </div>

                    <InputLabel label="Type" />

                    {training_type && (
                      <div className="flex justify-between w-full">
                        <SelectionButton
                          text={trainingOption.VIRTUAL}
                          checked={
                            training_type.toUpperCase() === trainingOption.VIRTUAL.toUpperCase()
                          }
                          value={trainingOption.VIRTUAL}
                          onClick={() => {
                            this.setState({ training_type: trainingOption.VIRTUAL });
                          }}
                        />

                        <SelectionButton
                          text={trainingOption.INDIVIDUAL}
                          checked={
                            training_type.toUpperCase() === trainingOption.INDIVIDUAL.toUpperCase()
                          }
                          value={trainingOption.INDIVIDUAL}
                          onClick={() => {
                            this.setState({
                              training_type: trainingOption.INDIVIDUAL,
                            });
                          }}
                        />

                        <SelectionButton
                          text={trainingOption.GROUP}
                          checked={
                            training_type.toUpperCase() === trainingOption.GROUP.toUpperCase()
                          }
                          value={trainingOption.GROUP}
                          onClick={() => {
                            this.setState({ training_type: trainingOption.GROUP });
                          }}
                        />
                      </div>
                    )}

                    <DurationPicker
                      minDuration={minDuration}
                      cusDuration={cusDuration}
                      setCusDuration={cusDuration => this.setState({ cusDuration })}
                      setMinDuration={minDuration => this.setState({ minDuration })}
                    />

                    <div className="flex justify-between mt-2">
                      <div className="w-1/2 pr-1">
                        <InputLabel
                          label={`Training Name (${eventName?.length || 0}/35 characters)`}
                          color={eventName?.length === 35 && 'red'}
                        />
                        <Form.Control
                          type="text"
                          id="custom-group"
                          maxLength={35}
                          placeholder="Offensive Training"
                          className="font-sf-regular bg-transparent text-black text-xs mr-2"
                          onChange={e => {
                            this.onChange('eventName', e.target.value);
                            this.onChange(
                              'link',
                              e.target.value.toLowerCase().replace(/\s/g, '').replace(/-/g, '')
                            );
                          }}
                          value={eventName}
                          required
                        />
                      </div>

                      <div className="w-1/2 pr-1">
                        <InputLabel label="Cost" />
                        <CFormGroup id="custom-group">
                          <div className="text-left">
                            <NumberFormat
                              required
                              value={price}
                              thousandSeparator={true}
                              placeholder="$ 0.00"
                              allowNegative={false}
                              className="font-sf-regular bg-transparent text-black text-xs rounded form-control"
                              prefix={'$ '}
                              onValueChange={({ formattedValue, value }) => {
                                this.onChange('price', value);
                              }}
                            />
                          </div>
                        </CFormGroup>
                      </div>
                    </div>

                    <Form.Group>
                      {training_type !== trainingOption.VIRTUAL && (
                        <div
                          className="flex flex-col"
                          key={locations?.length + locationsNew?.length}>
                          {locations
                            .filter(item => !item.attributes._destroy)
                            .map((item, index) => {
                              return (
                                <ServiceLocation
                                  hideRemove={index == 0 && true}
                                  allLocations={locations.filter(loc => !loc.attributes._destroy)}
                                  id={item.attributes.id}
                                  locationValue={item.attributes.location}
                                  totalCharacters={item.attributes.location?.length || 0}
                                  addressValue={item.attributes.address}
                                  onUpdateLocations={(id, tag, value) =>
                                    this.onUpdateOldLocations(id, tag, value)
                                  }
                                  removeLocation={id => this.removeOldLocation(id)}
                                />
                              );
                            })}

                          {locationsNew.map(item => (
                            <ServiceLocation
                              id={item.id}
                              locationValue={item.location}
                              addressValue={item.address}
                              totalCharacters={item.location?.length || 0}
                              onUpdateLocations={(id, tag, value) =>
                                this.onUpdateNewLocations(id, tag, value)
                              }
                              removeLocation={id => this.removeNewLocation(id)}
                            />
                          ))}
                          <div
                            className="my-1 cursor-pointer add-location-btn"
                            onClick={() => this.addLocation()}>
                            <span className="text-blue-500">
                              {[...locations, ...locationsNew].length > 0
                                ? '+ Add Another Location'
                                : '+ Add Location'}
                            </span>

                            <Tour
                              steps={addLocationGuide}
                              isOpen={this.state.showGuide}
                              accentColor={accentColor}
                              onRequestClose={() => this.setState({ showGuide: false })}
                              showNavigation={false}
                              showButtons={false}
                            />
                          </div>
                        </div>
                      )}

                      {training_type === trainingOption.GROUP && (
                        <div className="flex flex-col">
                          <InputLabel label="Available Spots" />
                          <div className="text-center w-full">
                            <Select
                              className="border-t-0 border-l-0 border-r-0 font-sf-regular text-xs text-black "
                              placeholder="Available spots"
                              isSearchable={false}
                              required
                              value={maxSeats}
                              onChange={option => this.onChange('maxSeats', option)}
                              options={availableSlots}
                            />
                          </div>
                        </div>
                      )}

                      {training_type === trainingOption.VIRTUAL && (
                        <>
                          <div>
                            <InputLabel label="Connection details" />
                            <Form.Control
                              type="text"
                              placeholder="Zoom link, Google Meet link"
                              className="font-sf-regular text-black text-xs connection-details-input"
                              onClick={() => this.setState({ showGuide: false })}
                              onChange={e => {
                                this.setState({ showGuide: false });
                                this.onChange('connectionDetails', e.target.value);
                              }}
                              value={connectionDetails}
                              required
                            />
                          </div>

                          <Tour
                            steps={addConnectionDetailsGuide}
                            isOpen={this.state.showGuide}
                            accentColor={accentColor}
                            onRequestClose={() => this.setState({ showGuide: false })}
                            showNavigation={false}
                            showButtons={false}
                          />
                        </>
                      )}
                    </Form.Group>

                    <CFormGroup>
                      <InputLabel
                        label={`Description (${desc?.length || 0}/160 characters)`}
                        color={desc?.length === 160 && 'red'}
                      />
                      <textarea
                        className="font-sf-regular text-input"
                        value={desc}
                        maxLength={160}
                        aria-multiline={true}
                        placeholder="Description"
                        rows={3}
                        id="ccnumber"
                        required
                        onChange={e => {
                          this.onChange('desc', e.target.value);
                        }}
                      />
                    </CFormGroup>

                    <CFormGroup>
                      <InputLabel label="Event link" />

                      <div className="flex md:items-center flex-col md:flex-row">
                        <span className="font-sf-regular text-sm mr-2 text-black">{`trayvo.com/${currentUser?.attributes?.slug}/`}</span>

                        <Form.Control
                          type="text"
                          className=" font-sf-regular bg-transparent text-black text-xs"
                          onChange={e => {
                            this.setState({ link: e.target.value.toLowerCase() });
                          }}
                          value={removeSpecialCharacters(link)}
                          required
                        />
                      </div>
                    </CFormGroup>

                    <div className="w-full">
                      <Select
                        className="primary-text-regular normal-case"
                        placeholder="Privacy"
                        isSearchable={false}
                        value={privacySetting}
                        onChange={option => this.setState({ privacySetting: option })}
                        options={privacySettings}
                      />
                    </div>

                    <div className="flex flex-row-reverse mt-3">
                      <button
                        type="submit"
                        className="ml-2 px-3 py-2 bg-primary-color text-white rounded p-1 hover:bg-blue-700 text-xs inline-flex justify-center">
                        Update Training Option
                        <ButtonLoader
                          visible={buttonLoading}
                          type="ThreeDots"
                          color="white"
                          className="ml-2 self-center"
                          height={10}
                          width={25}
                        />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <Loader />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default enhancer(EditTraining);
